import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { copyPrescriptionNotes, formatPrescriptionNote, formatProgramNotes } from "@/lib/prescriptionNotes";

export default function CopyForNotesButton({ prescription, prescriptions, compact = false, label }) {
  const isProgram = Array.isArray(prescriptions);
  const value = isProgram ? formatProgramNotes(prescriptions) : formatPrescriptionNote(prescription || {});
  const copy = async () => {
    try {
      await copyPrescriptionNotes(value);
      toast.success("Copied to clipboard");
    } catch {
      toast.error("Clipboard access is unavailable");
    }
  };
  return <Button type="button" size="sm" variant="outline" disabled={!value} onClick={copy} className="worksheet-note-controls"><Copy size={compact ? 15 : 16} /> {label || (isProgram ? "Copy All for Notes" : "Copy for Notes")}</Button>;
}
